module.exports = __webpack_public_path__ + "img/90501208hk.c7619862.png";